/* eslint-disable no-unused-vars */
import React from "react"
import { Text, View, Image } from "@react-pdf/renderer"
import { styles } from "./styles"

export const HeaderPersonalInformation = ({ customer }) => {
  return (
    <View style={styles.header} fixed>
      <View style={styles.boxImage}>
        {customer?.cust_clogo && <Image style={styles.logo} src={customer?.cust_clogo} />}
      </View>
      <View style={styles.clientInfo}>
        <Text style={styles.clientName}>{customer?.cust_cfantasyname}</Text>
        <Text style={styles.socialReason}>{customer?.cust_cname}</Text>
        <View style={styles.personalInfos}>
          <Text style={styles.personalInfo}>
            {customer?.cust_ctype === "PJ" ? customer.cust_ccnpj : customer?.cust_ccpf}
          </Text>
        </View>
      </View>
    </View>
  )
}
